import axios from 'axios'
import { MessageBox, Message } from 'element-ui'

// 创建axios实例
const request = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL: '',
    // 超时
    timeout: 20000
})

// request拦截器
request.interceptors.request.use(config => {
    // config.headers['Content-Type'] = 'application/json;charset=utf-8';
    return config
}, error => {
    //console.log(error)
    Promise.reject(error)
})

// 响应拦截器
request.interceptors.response.use(res => {
    const code = res.status;
    // 获取错误信息
    const msg = res.statusText
    if (code !== 200) {
        Message({
            message: msg,
            type: 'error',
            duration: 5 * 1000
        })
      return Promise.reject('error')
    } else {
      return res.data
    }
},
error => {
    let { message } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    }
    else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    }
    else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
})

export default request